import { TextField } from '@material-ui/core'
import React from 'react'

import { textInputStyles } from '../../styles/InputStyles'

type Props = {
    error?: boolean
    label?: string;
    underText?: string;
    type?: string;
    onChange?: (value: any) => void;
    onSubmit?(): void;
    onBlur?(): void;
    value?: string;
    onKeyPress?: (value: string, event: React.KeyboardEvent<HTMLDivElement>) => void
    fullWidth?: boolean,
    disabled?: boolean,
    required?: boolean,
    helperText?: string
}

export const TextInputEx: React.FC<Props> = ({
    error,
    label,
    underText,
    helperText,
    type,
    onChange,
    onSubmit,
    onBlur,
    value,
    onKeyPress,
    fullWidth,
    disabled,
    required
}) => {

    const styles = textInputStyles()

    const actuallyError = error && !!value && value.length > 0
    const rejectedFieldMessage = (helperText && actuallyError) ? helperText : ''

    const handleFormSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        if (onSubmit) {
            onSubmit()
        }
    }

    return (
        <form className={styles.container} noValidate autoComplete="off" onSubmit={handleFormSubmit}>
            <TextField
                error={actuallyError}
                onKeyPress={(e) => onKeyPress && onKeyPress(e.key, e)}
                onChange={(e) => onChange && onChange(e.target.value)}
                onSubmit={onSubmit}
                onBlur={onBlur}
                label={label}
                fullWidth={fullWidth}
                value={value}
                disabled={disabled}
                required={required}
                variant="outlined"
                helperText={rejectedFieldMessage || (actuallyError ? 'Invalid value' : '')}
                type={type}
                InputLabelProps={{
                    classes: {
                        root: styles.cssLabel,
                        focused: styles.cssFocused,

                    },
                }}
                InputProps={{
                    classes: {
                        root: styles.cssOutlinedInput,
                        focused: styles.cssFocused,
                        notchedOutline: styles.notchedOutline,

                    }
                }}/>
            <small>{underText}</small>
        </form>
    )
}

TextInputEx.defaultProps = {
    error: false,
    label: '',
    underText: '',
    type: undefined,
    onChange: undefined,
    onSubmit: undefined,
    onBlur: undefined,
    value: '',
    onKeyPress: undefined,
    fullWidth: false,
    disabled: false,
    required: false,
    helperText: ''
}
